import React, { FC } from "react";
import { Box, Button, Grid, Hidden, makeStyles, Typography } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import ExitToApp from "@material-ui/icons/ExitToApp";
import PhoneIcon from "@material-ui/icons/Phone";
import { ResponsiveGrid } from "./ResponsiveGrid";
import { useSelector } from "react-redux";
import { intermediarioSelector } from "../store/intermediario/intermediario.selectors";

const useStyles = makeStyles((theme) => ({
  header: {
    background: theme.palette.primary.dark, // todo review colors globally
    height: 80,

    fontSize: 24,
    letterSpacing: 0,
    lineHeight: "23px",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "nowrap",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      fontSize: 18,
    },
  },
  headerContainer: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  body: {
    height: 300,
    backgroundColor: theme.palette.primary.light,
    borderRadius: "0 0 15px 15px", // #FBED42 with opacity = 0.2
    justifyContent: "space-evenly",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      height: "initial",
      alignItems: "center",
    },
  },
  box: {
    paddingTop: 60,
    paddingBottom: 74,
    maxWidth: 220,
    [theme.breakpoints.down("sm")]: {
      padding: "0",
      maxWidth: "initial",
      paddingBottom: 54,
      paddingTop: 0,
      width: 250,
      "&:first-child": { paddingTop: 35 },
    },
  },
  boxTitle: {
    lineHeight: "1.3em",
    marginBottom: "0.5em",
  },
  boxBody: {
    height: 48,
    fontWeight: 300,
    marginBottom: 14,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 18,
      maxHeight: 48,
    },
  },
  button: {
    width: 247,
    height: 48,
    textTransform: "initial",
    display: "flex",
    justifyContent: "space-around",
    "& a": {
      textDecoration: "unset",
      color: theme.palette.primary.contrastText,
    },
  },
  linkButton: {
    textDecoration: "unset",
  },
  phoneIcon: {
    padding: 22,
    marginTop: 4,

    [theme.breakpoints.down("sm")]: {
      padding: "22px 8px",
    },
  },
  telefono: {
    color: theme.palette.primary.contrastText,
    textDecoration: "none",
  },
}));

export const Support: FC = () => {
  const classes = useStyles();
  const intermediarioState = useSelector(intermediarioSelector);
  const { data: intermediario } = intermediarioState;

  return (
    <>
      <ResponsiveGrid id={"support"}>
        <Grid container className={classes.header}>
          <Box component="div">
            <PhoneIcon className={classes.phoneIcon} />
          </Box>
          <Box className={classes.headerContainer}>
            <Hidden smDown>
              <Typography variant="h4">
                Hai bisogno di un supporto?{" "}
                <strong>
                  <a className={classes.telefono} href={"tel:" + intermediario?.telefono}>
                    {" "}
                    Contattaci al {intermediario?.telefono || "045 8290411"}
                  </a>
                </strong>
              </Typography>
            </Hidden>
            <Hidden mdUp>
              <Typography variant="subtitle1" style={{ lineHeight: "23px" }}>
                Hai bisogno di un supporto?
                <br />
                <strong>
                  <a className={classes.telefono} href={"tel:" + intermediario?.telefono}>
                    {" "}
                    Contattaci al {intermediario?.telefono || "045 8290411"}
                  </a>
                </strong>
              </Typography>
            </Hidden>
          </Box>
        </Grid>

        <Grid container className={classes.body}>
          <Grid item className={classes.box}>
            <Typography variant={"h3"} className={classes.boxTitle}>
              Set informativo
            </Typography>
            <Typography variant={"body1"} className={classes.boxBody}>
              Scarica una copia del Set Informativo
            </Typography>
            <a
              href={"https://www.arag.it/si/download/I/FP/FP/tradizionale_standard/IT"}
              target={"_blank"}
              rel="noopener noreferrer"
              className={classes.linkButton}
            >
              <Button
                variant="contained"
                endIcon={<GetAppIcon />}
                className={classes.button}
                color="primary"
                disableElevation
              >
                Scarica il documento
              </Button>
            </a>
          </Grid>
          <Grid item className={classes.box}>
            <Typography variant={"h3"} className={classes.boxTitle}>
              FAQ
            </Typography>
            <Typography className={classes.boxBody}>Hai bisogno di aiuto?</Typography>
            <a
              href={process.env.REACT_APP_FAQ_LINK}
              target={"_blank"}
              className={classes.linkButton}
              rel="noopener noreferrer"
            >
              <Button
                variant="contained"
                endIcon={<ExitToApp />}
                className={classes.button}
                color="primary"
                disableElevation
              >
                Consulta il link
              </Button>
            </a>
          </Grid>
        </Grid>
      </ResponsiveGrid>
    </>
  );
};
